import React, { useContext } from 'react'
import { Hidden, Drawer, Box } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { AuthContext } from '../contexts/AuthContext'
import NavMenu from './NavMenu'
import { authService } from '../../lib/services'

const useStyles = makeStyles(theme => ({
    drawerPaper: {
        borderTop: '5px solid  #069d8e',
        borderLeft: '5px solid  #069d8e',
        borderBottom: '5px solid  #069d8e',
    },
}))

export default function SideNav() {
    const classes = useStyles()
    const { actAs } = useContext(AuthContext)
    return (
        <Hidden mdDown implementation="js">
            <Drawer open variant="permanent" classes={{ paper: actAs ? classes.drawerPaper : '' }}>
                <NavMenu />
            </Drawer>
        </Hidden>
    )
}
